import { NgModule } from '@angular/core';
import { TemplatesService } from './services/templates.service';

@NgModule({
  providers: [TemplatesService],
})
export class SolicitationModule {}
